import moment from 'moment'
const mobile = require('is-mobile')

const filterDefaultValues = {
  dateStart: null,
  dateEnd: null,
  maxPeople_from: 2,
  type: '', // Now multiple by comma
  region: '',
  bedrooms_from: null,
  bedrooms_to: null,
  csrId: null,
  page: 1,
  visible: true,
  priceRange: 'all',
  sortBy: 'sortOrder',
  rowsPerPage: 7,
  parking: 'all',
  pool: 'all',
  terrace: 'all',
  aircon: 'all',
  pets: 'all',
  bedroomsCount: 'all',
  bathroomCount: 'all',
  favorites: 0,
  dayPrice_from: 0,
  dayPrice_to: 1000
}

const bookingDataDefaults = {
  checkInTime: '16:00',
  checkOutTime: '12:00',
  payMonthly: false,
  customerName: null,
  customerPhone: null,
  customerEmail: null,
  confirmed: false,
  notes: '',
  flightDepartureInfo: '',
  flightArrivalInfo: '',
  infants: 0,
  adults: 2,
  kids: 0
}

export default {
  objectsCache: [], // Set when loading hot objects, used for selected object images preload
  objectPageContainerId: null, // Like carabela_3benalmadena_nueva_torrequebrada_malaga_costa_del_sol_spain
  defaultCsrFee: 45,
  scrolledTop: 0,
  lang: 'en',
  isHydrated: false,
  showArticleOnly: false,
  openTs: 0,
  favorites: [],
  languages: ['en', 'es', 'fi', 'et', 'ru'],
  priceObject: {},
  showBookNowForm: false,
  loadingObjectInfo: false,
  metaSiteName: 'Costasolrent.com',
  metaUrl: 'https://www.costasolrent.com',
  metaTitle: null,
  metaDescription: null,
  metaImage: null,
  defaultMetaUrl: 'https://www.costasolrent.com',
  defaultMetaTitle: 'Costasolrent.com',
  defaultMetaDescription: "Costasolrent.com offers quality holiday and real estate accommodation in Spain's Costa del Sol.",
  defaultMetaImage: 'https://www.costasolrent.com/img/costasolrent_logo.png',
  metaType: 'article',
  detailedSearch: false,
  bookingExtras: [],
  bookingExtrasSelected: {},
  objectRegions: [],
  showSearchPickerFor: null,
  showBookingPickerFor: null,
  personTypes: ['adults', 'kids', 'infants'],

  featuresList: {},
  featureGroups: [],
  filtersHash: null,
  objectRoomTypesById: {},
  translationsByLang: {},
  bookingStatuses: {
    '5bebc64a46853c27bcfe3dc8': 'confirmed',
    '5bebc64446853c27bcfe3dc7': 'new',
    '5e5a0fba9c2acb1241c0798d': 'owner',
    '5bebc65846853c27bcfe3dca': 'archived'
  },
  bookingData: JSON.parse(JSON.stringify(bookingDataDefaults)),
  bookingDataDefaults: JSON.parse(JSON.stringify(bookingDataDefaults)),
  bookNowObject: {},
  bookNowAvailable: false,
  hotImages: [],
  isHomepage: true,
  progressSearching: false,
  progressOpening: false,
  progressHot: true,
  templateVarsByLang: {},
  pageId: null,
  menuResponse: [],
  pagesById: {},
  pagesBySeoName: {},
  bannersByLang: {},
  galleriesByArticleId: {},
  searchResult: [],
  searchTotal: 0,
  selectedObject: {
    bookedDays: {},
  },

  // Image
  showingFullImage: false,
  previewImage1: {},
  previewImage2: {},
  fullImage1: {},
  fullImage2: {},
  previewSideImage2: {},
  previewSideImage3: {},
  imageUrl1: null,
  imageUrl2: null,
  image1Transparent: false,
  image2Transparent: true,
  selectedImageIndex: 0,
  whichImageShowing: 1,
  showingImageNavigation: !!mobile(),
  imagePreviewThumbnailLeftOffset: 0,
  imageAutoSwitchTimer: null,
  s3url: 'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/',
  preloadImg1: null,
  preloadImg2: null,
  mobile: mobile(),
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  contentAreaWidth: 837,

  calendarYear: moment().format('Y'),
  calendarMonth: moment().format('MM'),
  checkInCalendarYear: moment().format('Y'),
  checkInCalendarMonth: moment().format('MM'),
  showLeftMenu: false,
  showRightMenu: false,
  showEmailModal: false,
  rowsPerHomePage: 12,
  searchFilters: JSON.parse(JSON.stringify(filterDefaultValues)),
  filterDefaultValues: JSON.parse(JSON.stringify(filterDefaultValues)),
  weather: {},
  weatherNightIcons: {
    sunny: 'moon',
    partlycloudy: 'moon'
  },
  weatherCodes: {},
}
